<template>
    <div>
        <b-card align="left" :title="titulo" border-variant="light">
            <b-card-text>
                <b-form @submit.prevent="guardar" @reset="cancelar">
                    <b-form-group label-for="gestion" label="Gestión:" label-size="lg">
                    <b-form-input id="gestion" v-model="gestion" size="lg" class="mb-3" readonly></b-form-input>
                    </b-form-group>
                    <b-form-group label-for="colegio" label="Colegio:" label-size="lg">
                    <b-form-input id="colegio" v-model="colegio" size="lg" class="mb-3" readonly></b-form-input>
                    </b-form-group>
                    <b-form-group label-for="grado" label="Grado:" label-size="lg">
                    <b-form-select id="grado" v-model="grado" :options="opcionesGrado" :state="gradoValido" size="lg" class="mb-3" autofocus required></b-form-select>
                    </b-form-group>
                    <b-form-group label-for="nombre" label="Curso:" label-size="lg" :invalid-feedback="cursoNoValido">
                    <b-form-input id="nombre" v-model="nombre" :state="nombreValido" size="lg" class="mb-3" autocomplete="off" placeholder="Ingrese nombre curso" required trim></b-form-input>
                    </b-form-group>
                    <b-button type="submit" variant="danger" size="lg" class="mt-3">Guardar</b-button>
                    <b-button type="reset" size="lg" class="ml-3 mt-3">Cancelar</b-button>
                </b-form>
            </b-card-text>
        </b-card>
    </div>
</template>
<script>
import {mapState, mapMutations} from 'vuex'
export default {
    name: 'Curso',
    props: {
        titulo: '',
        estado: ''
    },
    data() {
        return {
            gestion: 0,
            colegio: '',
            nombre: '',
            grado: null,
            opcionesGrado: [
                {value: null, text: 'Seleccione grado'},
                {value: 1, text: 'Primero'},
                {value: 2, text: 'Segundo'},
                {value: 3, text: 'Tercero'},
                {value: 4, text: 'Cuarto'}
            ],
            colegio_id: 0,
            curso_id: 0,
        }
    },
    created() {
        if (this.estado === 'crear') {
            this.gestion = this.planilla[1].gestion
            this.colegio = this.planilla[1].nombre + ' - ' + this.planilla[1].distrito
            this.colegio_id = this.planilla[1]._id
        } else if (this.estado === 'editar') {
            this.gestion = this.planilla[1].gestion
            this.colegio = this.planilla[1].nombre + ' - ' + this.planilla[1].distrito
            this.colegio_id = this.planilla[1]._id
            this.grado = this.planilla[2].grado
            this.nombre = this.planilla[2].nombre
            this.curso_id = this.planilla[2]._id
        }
    },
    computed: {
        ...mapState(['cursos','planilla']),
        mostrar: {
            get () {return this.$store.state.mostrar_form_curso},
            set (valor) {this.$store.commit('mostrarFormCurso', valor)}
        },
        gradoValido() {
            return this.grado ? true: null
        },
        nombreValido() {
            let len = this.nombre.length
            if (len === 0) return null
            if (len > 4) return this.existeCurso(this.nombre, this.grado, this.curso_id) ? false: true
            return false
        },
        cursoNoValido() {
            if (this.existeCurso(this.nombre, this.grado)) return 'Ya existe!!'
            else return 'Ingrese por lo menos 5 caracteres'
        }
    },
    methods: {
        ...mapMutations(['agregarCurso','actualizarCurso']),
        existeCurso(nombre, grado, id) {
            return this.cursos.some(item => item.nombre.toUpperCase() === nombre.toUpperCase() && item.grado === grado && item._id !== id) ? true: false
        },
        guardar() {
            if (this.nombreValido && this.gradoValido) {
                console.log('Estado...', this.estado)
                if (this.estado === 'crear') {
                    this.axios.post('/cursos', {nombre: this.nombre, grado: this.grado, colegioId: this.colegio_id})
                        .then(res => {
                            this.agregarCurso(res.data)
                        })
                        .catch(e => {
                            console.log(e)
                        })
                } else {
                    //update
                    this.axios.put(`/cursos/${this.curso_id}`, {nombre: this.nombre, grado: this.grado})
                        .then(res => {
                            this.actualizarCurso(res.data)
                        })
                        .catch(e => {
                            console.log(e)
                        })
                }
                this.nombre = ''
                this.grado = ''
                this.mostrar = false
            }
        },
        cancelar() {
            this.nombre = ''
            this.grado = ''
            this.mostrar = false
        }
    }
}
</script>